import React from 'react';
import { useModal } from '../_contexts';
import { Modal, Button, Icon } from '../_components';

export function OnboardEnd() {
  const { openModal, closeModal } = useModal();

  const handleDocs = (ev) => {
    openModal('help', { firstTime: true });
  };
  const handleClose = (ev) => {
    closeModal();
  };
  const handleTimeline = (ev) => {
    openModal('newTimeline', { prevModal: 'timelineManager' });
  };

  return (
    <Modal
      id="onboardingEndModal"
      // backdrop
      title="Setup Complete"
      icon="far fa-check fa-fw"
      size="md"
      open
      onClose={() => closeModal(null)}
    >
      <div className="chronos-end-setup">
        <p>
          Congratulations! Your Chronicle has been setup, and is now ready to
          edit. You can familiarize yourself with the Documentation, jump into
          creating a Timeline, or close this window to begin your own workflow.
        </p>
        <p>
          You can always access the Documentation/Help system by clicking on the{' '}
          <Icon icon="far fa-question-circle fa-fw" /> icon
        </p>
        <div className="d-flex w-100 justify-content-between">
          <Button color="info" onClick={handleDocs}>
            <Icon icon="far fa-book-spells fa-fw" />
            &nbsp;Documentation
          </Button>
          <Button color="secondary" onClick={handleClose}>
            <Icon icon="far fa-times fa-fw" />
            &nbsp;Close
          </Button>
          <Button color="primary" onClick={handleTimeline}>
            <Icon icon="far fa-bars fa-fw" />
            &nbsp;Create Timeline
          </Button>
        </div>
      </div>
    </Modal>
  );
}
